module.exports = __webpack_public_path__ + "img/title-video-placeholder@2x.edbfb338.jpg";